import React from 'react'
import MaterialSymbol from '../material-symbol'

const Book = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="book" {...props} />
))

Book.displayName = 'Book'

export default Book
